import React from 'react';
import { TargetIcon, ListChecksIcon, LayoutGridIcon, ClipboardListIcon, BrainIcon, BarChart3Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { scrollToBuy } from '../utils/constants';
const MODULES = [{
  number: '01',
  title: 'Advanced Technical Development™',
  icon: TargetIcon,
  lead: 'Advanced progressions and correction systems to develop technical performance and solve specific problems on court.',
  body: '',
  tags: 'Volleys · Bandeja · Víbora · Smash · Walls · Lobs · Transitions'
}, {
  number: '02',
  title: 'Professional Drill Library™',
  icon: ListChecksIcon,
  lead: 'Access structured, court-ready drills designed around clear technical and tactical objectives.',
  body: 'Each drill includes setup, execution, coaching cues, variations, progressions, and key observation points.',
  tags: 'Technical · Tactical · Constraints · Progressions · Coaching Cues'
}, {
  number: '03',
  title: 'Session Design System™',
  icon: LayoutGridIcon,
  lead: 'Build professional sessions in minutes without starting every training day from a blank page.',
  body: 'Plan individual, pair, and group sessions with clear sequencing, workload, timing, and adaptations.',
  tags: 'Individual · Pair · Group · Sequencing · Workload · Adaptations'
}, {
  number: '04',
  title: 'Ready-To-Coach Sessions™',
  icon: ClipboardListIcon,
  lead: 'Open complete, professionally structured padel sessions whenever you need them.',
  body: 'Train defense, attack, transitions, net control, walls, consistency, point construction, and competitive situations.',
  tags: 'Objectives · Timing · Drills · Progressions · Coaching Instructions'
}, {
  number: '05',
  title: 'Tactical & Match Development™',
  icon: BrainIcon,
  lead: 'Develop players who understand when, where, and why to make the right decision.',
  body: 'Train positioning, point construction, transitions, shot selection, net recovery, pair coordination, and match scenarios.',
  tags: 'Positioning · Decisions · Transitions · Pair Play · Match Tactics'
}, {
  number: '06',
  title: 'Player Development & Coaching System™',
  icon: BarChart3Icon,
  lead: 'Evaluate performance, identify priorities, and turn observations into clear development actions.',
  body: 'Use professional assessments, development plans, progress tracking, feedback tools, and performance reviews.',
  tags: 'Assessments · Development Plans · Tracking · Feedback · Reviews'
}];
export function Modules() {
  return <section aria-labelledby="modules-title" className="w-full bg-ivory px-4 py-8 sm:px-6" data-id="element-124" data-mp="2rm2o78qg8fwh">
      <div className="mx-auto max-w-6xl" data-id="element-125" data-mp="2vmuwnzrhygrp">
        <div className="text-center" data-id="element-126" data-mp="3jds0ep9527rv">
          <span className="font-head text-[11px] font-semibold uppercase tracking-wider text-brand sm:text-xs" data-id="element-127" data-mp="3jcpaoknjybdj">
            The Complete Coaching Collection
          </span>
          <h2 id="modules-title" className="mt-1 font-display text-2xl uppercase leading-tight text-charcoal sm:text-4xl" data-id="element-128" data-mp="1cp82jajjaiqu">
            Inside the main box set — six complete professional modules
          </h2>
        </div>

        <div className="mt-4 grid gap-2.5 md:grid-cols-2 lg:grid-cols-3" data-id="element-129" data-mp="1mejer61pw3iy">
          {MODULES.map(mod => {
          const Icon = mod.icon;
          return <article key={mod.number} className="flex flex-col" data-id="element-130" data-mp="trosc3lcau2u">
                <button type="button" onClick={scrollToBuy} aria-label={`Get ${mod.title}`} className="flex h-full flex-col rounded-xl border border-charcoal/10 bg-white p-3.5 text-left transition hover:border-brand" data-id="element-131" data-mp="orspi7odp8ov">
                  <div className="flex items-center gap-2" data-id="element-132" data-mp="2f3gryur2na4u">
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-dark text-white" data-id="element-133" data-mp="2f62ziudyppn2">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-134" data-mp="jnrx26llzvn3" />
                    </span>
                    <span className="font-head text-[10px] font-semibold uppercase tracking-widest text-brand" data-id="element-135" data-mp="omv1botrlxu0">
                      Module {mod.number}
                    </span>
                  </div>
                  <h3 className="mt-2 font-display text-lg uppercase leading-tight text-charcoal sm:text-xl" data-id="element-136" data-mp="xnjhap2py89j">
                    {mod.title}
                  </h3>
                  <p className="mt-1 text-[13px] leading-snug text-charcoal" data-id="element-137" data-mp="12mdxrkd7rkqh">{mod.lead}</p>
                  {mod.body ? <p className="mt-1 text-[13px] leading-snug text-softgray" data-id="element-138" data-mp="17je6k31g71la">{mod.body}</p> : null}
                  <p className="mt-2 border-t border-charcoal/10 pt-1.5 font-head text-[11px] font-semibold uppercase leading-snug tracking-wide text-brand-dark" data-id="element-139" data-mp="1gdspqgp3mw9o">
                    {mod.tags}
                  </p>
                </button>
              </article>;
        })}
        </div>

        <div className="mt-6 flex flex-col items-center" data-id="element-140" data-mp="20goncmfpuaab">
          <CtaButton data-id="element-141" data-mp="20e2gkp0nfyt5" />
          <TrustRow className="mt-2" data-id="element-142" data-mp="1vh2bohfjd23m" />
        </div>
      </div>
    </section>;
}